import { postEmailSendOtp } from "../../../../helpers/fakebackend_helper";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const reKyc_send_email_otpThunk = createAsyncThunk(
  "reKyc_send_email_otpThunk",
  async ({ params, token }) => {
    try {
      const response = postEmailSendOtp(params, token);
      return response;
    } catch (error) {
      return error;
    }
  }
);
